import { createGlobalStyle } from 'styled-components';
import { CustomStylesProps } from './theme.types';

const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-regular.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-regular.woff') format('woff');
            font-weight: 400;
            font-style: normal;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-regular-italic.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-regular-italic.woff') format('woff');
            font-weight: 400;
            font-style: italic;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-medium.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-medium.woff') format('woff');
            font-weight: 500;
            font-style: normal;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-medium-it.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-medium-it.woff') format('woff');
            font-weight: 500;
            font-style: italic;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-semibold.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-semibold.woff') format('woff');
            font-weight: 600;
            font-style: normal;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-semibold-italic.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-semibold-italic.woff') format('woff');
            font-weight: 600;
            font-style: italic;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-bold.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-bold.woff') format('woff');
            font-weight: 700;
            font-style: normal;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-bold-italic.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-bold-italic.woff') format('woff');
            font-weight: 700;
            font-style: italic;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-extrabold.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-extrabold.woff') format('woff');
            font-style: normal;
            font-weight: 800;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-extrabold-italic.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-extrabold-italic.woff') format('woff');
            font-style: italic;
            font-weight: 800;
            font-display: fallback;
    }
    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-black.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-black.woff') format('woff');
            font-style: normal;
            font-weight: 900;
            font-display: fallback;
    }

    @font-face {
        font-family: 'proxima-nova';
        src:  url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-black-italic.woff2') format('woff2'),
            url('https://www.mlbstatic.com/mlb.com/fonts/proxima-nova-black-italic.woff') format('woff');
            font-style: italic;
            font-weight: 900;
            font-display: fallback;
    }


    ${(props: CustomStylesProps) => props.customStyles}
`;

export default GlobalStyles;
